import Department from "src/modules/setting/user-management/department/Department";
import Role from "src/modules/setting/user-management/role/Role";
import AddEditRole from "src/modules/setting/user-management/role/AddEditRole";
import Users from "src/modules/setting/user-management/users/Users";
import AddUser from "src/modules/setting/user-management/users/add-user/AddUser";
import lang from "src/lang";
import ClientNote from "../predifined-notes/client-note/ClientNote";
import TermsConditions from "../predifined-notes/terms-conditions/TermsConditions";

const UserManagementRoutes = [
  {
    access: { key: "user_department", action: "view" },
    label: lang.get("user", ["Departments"]),
    key: "modules/setting/users/department",
    element: <Department />,
    navigation: false,
  },
  {
    access: { key: "user_role", action: "view" },
    label: lang.get("user", ["Roles"]),
    key: "modules/setting/users/role",
    element: <Role />,
    navigation: false,
  },
  {
    access: { key: "user_role_add", action: "create" },
    label: lang.get("user", ["Add Role"]),
    key: "modules/setting/users/role/add",
    element: <AddEditRole />,
    navigation: false,
  },
  {
    access: { key: "user_role_edit", action: "edit" },
    label: lang.get("user", ["Edit Role"]),
    key: "modules/setting/users/role/:id",
    element: <AddEditRole />,
    navigation: false,
  },
  {
    access: { key: "user_users", action: "view" },
    label: lang.get("user", ["Users"]),
    key: "modules/setting/users",
    element: <Users />,
    navigation: false,
  },
  {
    access: { key: "user_add_user", action: "create" },
    label: lang.get("user", ["Add User"]),
    key: "modules/setting/users/add",
    element: <AddUser />,
    navigation: false,
  },
  {
    access: { key: "user_edit_user", action: "edit" },
    label: lang.get("user", ["Edit User"]),
    key: "modules/setting/user/:id",
    element: <AddUser />,
    navigation: false,
  },
    {
    access: { key: "client_notes", action: "view" },
    label: lang.get("settings", ["Client Notes"]),
    key: "modules/setting/predifined-notes/client-notes",
    element: <ClientNote />,
    navigation: false,
  },
      {
    access: { key: "terms_conditions", action: "view" },
    label: lang.get("settings", ["Terms & Conditions"]),
    key: "modules/setting/predifined-notes/terms-conditions",
    element: <TermsConditions />,
    navigation: false,
  },
];

export default UserManagementRoutes;
